import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { SurveyFormBuilder } from '../components/SurveyFormBuilder';
import type { FormStructure } from '../features/surveys/types';
import type { QmsRegistryKind } from '../features/qms/qmsApi';
import { fetchActiveFormVersion, saveFormTemplate } from '../features/qms/qmsApi';

interface Props {
  kind: QmsRegistryKind;
  title: string;
  basePath: string;
}

export function QmsFormTemplatePage({ kind, title, basePath }: Props) {
  const [structure, setStructure] = useState<FormStructure>({ fields: [] });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [saved, setSaved] = useState('');

  useEffect(() => {
    (async () => {
      try {
        const fv = await fetchActiveFormVersion(kind);
        setStructure((fv.structure as FormStructure) ?? { fields: [] });
      } catch (e: unknown) {
        setError(e instanceof Error ? e.message : 'Error');
      } finally {
        setLoading(false);
      }
    })();
  }, [kind]);

  if (loading) {
    return (
      <div className='container max-w-4xl py-8 px-4'>
        <p className='text-muted-foreground'>Cargando plantilla…</p>
      </div>
    );
  }

  return (
    <div className='container max-w-4xl py-8 px-4'>
      <div className='mb-6 flex justify-between items-center'>
        <h1 className='text-2xl font-semibold'>{title} — Campos dinámicos</h1>
        <Link to={basePath} className='text-sm text-primary hover:underline'>
          Volver
        </Link>
      </div>
      {error && <p className='text-destructive text-sm mb-4'>{error}</p>}
      {saved && <p className='text-green-600 text-sm mb-4'>{saved}</p>}
      <p className='text-xs text-muted-foreground mb-4'>
        Para plantilla vacía o incompleta use «Guardar como borrador». «Publicar» exige al menos un campo con
        etiqueta válida.
      </p>
      <SurveyFormBuilder
        initialStructure={structure}
        isPublished={false}
        error=''
        onCancel={() => {}}
        onSubmit={async (s) => {
          setError('');
          setSaved('');
          try {
            await saveFormTemplate(kind, s);
            setSaved('Plantilla guardada');
            setStructure(s);
          } catch (e: unknown) {
            setError(e instanceof Error ? e.message : 'Error al guardar');
          }
        }}
      />
    </div>
  );
}
